// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import $ from 'jquery'
import './less/common.less'
import 'weui'
import weui from 'weui.js'
import { env } from './js/url';
import { saveOpenArticle } from './js/savePoints'
import getParamsFromUrl from './js/getParamsFromUrl'

Vue.config.productionTip = false

router.beforeEach((to, from, next) => {
  if(to.path === '/rule'){
    document.title = '打榜规则';
  }else{
    document.title = '人气排行榜';
  }
  next();
})
// if (env !== "pro") {
//   // console.log(eruda, 'eruda')
//   //动态引入eruda
//   const eruda = require("eruda")
//   eruda.init()
// }
// 打开新闻埋点
saveOpenArticle(getParamsFromUrl().articleId)

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js